import { render, staticRenderFns } from "./AmountInput.vue?vue&type=template&id=0f464d26&scoped=true&lang=pug&"
import script from "./AmountInput.vue?vue&type=script&lang=ts&"
export * from "./AmountInput.vue?vue&type=script&lang=ts&"
import style0 from "./AmountInput.vue?vue&type=style&index=0&id=0f464d26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f464d26",
  null
  
)

export default component.exports